import { usePreferences } from "@/composables/usePreferences";
import { useChatStore } from "@/stores/chatStore";

export default defineNuxtPlugin(() => {
  const { isAuthenticated } = useSanctumAuth();

  const { clearPreferences } = usePreferences();
  const chatStore = useChatStore();

  onNuxtReady(async () => {
    // Clear local storage when the user logs out
    watch(isAuthenticated, async (newValue) => {
      if (!newValue) {
        // Clearing preferences alone only wipes the persisted values - the
        // chat store's `id`/`messages` refs stay resident in memory (logout
        // navigates client-side, so the Pinia store instance survives),
        // leaving the previous user's chat visible. Reset it explicitly too.
        chatStore.reset();
        clearPreferences();
      }
    });
  });
});
